import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';

import { AlertField } from './alert-field';
import { CurrentUserField } from './current-user-field';
import { DependentChoicePicker } from './dependent-choice-picker';
import { FieldListPicker } from './field-list-picker';
import { FieldValueLabel } from './field-value-label';

export default createFrontendPlugin({
  extensions: [
    FormFieldBlueprint.make({
      name: 'field-list-picker',
      params: { field: async () => FieldListPicker },
    }),
    FormFieldBlueprint.make({
      name: 'dependent-choice-picker',
      params: { field: async () => DependentChoicePicker },
    }),
    FormFieldBlueprint.make({
      name: 'field-value-label',
      params: { field: async () => FieldValueLabel },
    }),
    FormFieldBlueprint.make({
      name: 'alert-field',
      params: { field: async () => AlertField },
    }),
    FormFieldBlueprint.make({
      name: 'current-user-field',
      params: { field: async () => CurrentUserField },
    }),
  ],
  pluginId: 'picker-shared',
});
